import BadgesAdapter, {
  // TODO: IGNORED JUST TO GET THIS DEPLOYED ASAP
  // @ts-ignore
  type BadgeComponent,
} from "./Badges/BadgesAdapter.svelte";
import DefaultBadge from "./Badges/variants/DefaultBadge.svelte";
import MicaraaBadge from "./Badges/variants/MicaraaBadge.svelte";
import ThisPlaceBadge from "./Badges/variants/ThisPlaceBadge.svelte";
import RookieBabyBadge from "./Badges/variants/RookieBabyBadge.svelte";
import ButtonsAdapter, {
  // TODO: IGNORED JUST TO GET THIS DEPLOYED ASAP
  // @ts-ignore
  type ButtonComponent,
} from "./Buttons/ButtonsAdapter.svelte";
import DefaultButton from "./Buttons/variants/DefaultButton.svelte";
import MybacsButton from "./Buttons/variants/MybacsButton.svelte";
import OoniqueButton from "./Buttons/variants/OoniqueButton.svelte";
import MicaraaButton from "./Buttons/variants/MicaraaButton.svelte";
import ThisPlaceButton from "./Buttons/variants/ThisPlaceButton.svelte";
import MozartButton from "./Buttons/variants/MozartButton.svelte";
import RookieBabyButton from "./Buttons/variants/RookieBabyButton.svelte";
import ModalsAdapter, {
  // TODO: IGNORED JUST TO GET THIS DEPLOYED ASAP
  // @ts-ignore
  type ModalComponent,
} from "./Modals/ModalsAdapter.svelte";
import DefaultModal from "./Modals/variants/DefaultModal.svelte";

export const BADGE_ID = "pina-app-badge";
export const BUTTON_ID = "pina-app-button";

export const buttonComponents: Record<string, ButtonComponent> = {
  ooniqueButton: OoniqueButton,
  mybacsButton: MybacsButton,
  micaraaButton: MicaraaButton,
  thisplaceButton: ThisPlaceButton,
  mozartButton: MozartButton,
  defaultButton: DefaultButton,
  rookiebabyButton: RookieBabyButton,
};

export const modalComponents: Record<string, ModalComponent> = {
  defaultModal: DefaultModal,
};

export const badgeComponents: Record<string, BadgeComponent> = {
  defaultBadge: DefaultBadge,
  micaraaBadge: MicaraaBadge,
  thisplaceBadge: ThisPlaceBadge,
  rookiebabyBadge: RookieBabyBadge,
};

export const components: Record<
  string,
  ButtonComponent | ModalComponent | BadgeComponent
> = {
  ...buttonComponents,
  ...modalComponents,
  ...badgeComponents,
};

export const getComponent = (component: keyof typeof components) => {
  const isPartOfGroup = (
    group:
      | typeof buttonComponents
      | typeof modalComponents
      | typeof badgeComponents,
    component: keyof typeof components,
  ) => Object.keys(group).includes(component);

  const isButton = isPartOfGroup(buttonComponents, component);
  const isModal = isPartOfGroup(modalComponents, component);
  const isBadge = isPartOfGroup(badgeComponents, component);

  if (isButton) {
    return {
      AdapterComponent: ButtonsAdapter,
      Component: components[component],
    };
  }

  if (isBadge) {
    return {
      AdapterComponent: BadgesAdapter,
      Component: components[component],
    };
  }

  if (isModal) {
    return {
      AdapterComponent: ModalsAdapter,
      Component: components[component],
    };
  }
};
